module.exports = __webpack_public_path__ + "static/media/colorado_springs_team.374bc63a.jpg";